export default __webpack_public_path__ + "static/media/accessibility.fa15af2d.svg";